import { generateLocale } from './generate.js';

export default generateLocale([
  'ニックネーム',
  '3バイト以上のニックネームをご入力ください.',
  'メールアドレス',
  'メールアドレスをご確認ください.',
  'サイト',
  'オプション',
  'ここにコメント',
  'コメントしましょう~',
  '提出する',
  'Like',
  'Cancel like',
  '返信する',
  'キャンセル',
  'コメント',
  '更新',
  'さらに読み込む',
  'プレビュー',
  '絵文字',
  '画像をアップロード',
  '秒前',
  '分前',
  '時間前',
  '日前',
  'たっだ今',
  'アップロード',
  'ログインする',
  'ログアウト',
  '管理者',
  'トップに置く',
  'ワード',
  'コメントは $0 から $1 ワードの間でなければなりません!\n 現在の単語番号: $2',
  '匿名',
  'うえにん',
  'なかにん',
  'しもおし',
  '特にしもおし',
  'かげ',
  'なぬし',
  'GIF',
  '探す GIF',
  '個人情報',
  '承認済み',
  '待っている',
  'スパム',
  'べたつかない',
  '逆順',
  '正順',
  '人気順',
  'どう思いますか？',
  'あなたのコメントは審査中で、現在はあなただけに表示されています。承認後に公開されます。',
  'この投稿のコメントを購読する',
  'このサイトのコメントを購読する',
  'あなたのコメントの返信を購読する',
]);
